import GpsPlanEntryRecordsRequest from "../../../api/raily/gps/plan-entry-records/gps-plan-entry-records-request";
import GpsPlanEntryRecordsParams from "./gps-plan-entry-records-params";

const create = (
  params: GpsPlanEntryRecordsParams,
): GpsPlanEntryRecordsRequest => {
  return {
    planEntryId: params.planEntryUuid,
  };
};

const gpsPlanEntryRecordsParamsFactory = {
  create,
};

export default gpsPlanEntryRecordsParamsFactory;
